module.exports = __webpack_public_path__ + "static/media/tabs-left.c844fda8.jpg";